import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

const muiStyles = makeStyles((theme: typeof muiTheme) => ({
    sidebarTile: {
        display: 'flex',
        flexDirection: 'column',
        textTransform: 'uppercase',
        fontSize: '13.5px',
        fontWeight: 'bold',
        lineHeight: '19px',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
        cursor: 'pointer',
        height: '102px',
        '&:hover': { filter: 'brightness(0) invert(1)' },
        '& > img': { marginBottom: '0.5rem' }
    },
    name: {
        marginTop: '.5rem',
        textAlign: 'center',
        color: '#888',
        fontSize: '11px'
    },
    active: { filter: 'brightness(0) invert(1)' },
    activeLink: {
        borderLeft: `5px solid ${theme?.app?.clientTheme.colors.sidebar?.accentColor ||
        theme?.app?.clientTheme.colors.highlightColor1 ||
        '#edda26'}`,
        padding: '0 7px 0 2px',
        backgroundColor: theme?.app?.clientTheme.colors.sidebar?.activeColor ||
            '#1e202c',
        textDecoration: 'none'
    },
    inactiveLink: { padding: '0 7px 0 7px' },
    link: {
        textDecoration: 'none',
        position: 'relative'
    },
    sidebarIcon: {
        width: '28px !important',
        height: '28px !important'
    },
    circle: {
        borderRadius: '100%',
        top: '5px',
        right: '15px',
        zIndex: 9999999,
        position: 'absolute',
        height: '25px',
        width: '25px',
        textAlign: 'center',
        background: 'red'
    },
    circleText: {
        marginTop: '7px',
        fontSize: '11px',
        fontWeight: 'bold',
        fontFamily: 'sans-serif',
        color: '#fff'
    }
}));

export default muiStyles;